import { AfterViewInit, Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { generateUUID } from 'src/app/core/generators/generateUUID';
import {
  ICreateLaudoHigienizacao,
  IEditLaudoHigienizacao,
  IGetLaudoHigienizacaoById
} from 'src/app/services/LaudoHigienizacaoService/laudo-higienizacao.model';
import Swal from 'sweetalert2';
import { formatarData } from 'src/app/core/utils/utilities';
import { ServicoEntradaService } from 'src/app/services/ServicoEntradaService/servicoEntrada.service';
import { IGetServicoEntradaByServicoEntradaCavalo } from 'src/app/services/ServicoEntradaService/servicoEntrada.model';
import { LaudoHigienizacaoService } from 'src/app/services/LaudoHigienizacaoService/laudo-higienizacao.service';
import { SwalAlertService } from 'src/app/services/SwalAlertService/swalAlert.service';
import { CaminhaoService } from 'src/app/services/CaminhaoService/caminhao.service';

type IOptions = {
  name: string;
  value: string | number;
};

@Component({
  selector: 'app-cadastro-laudo-higienizacao',
  templateUrl: './cadastro-laudo-higienizacao.component.html',
  styleUrls: ['./cadastro-laudo-higienizacao.component.scss']
})
export class CadastroLaudoHigienizacaoEmpresaComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  private subscription$ = new Subscription();
  form: FormGroup;
  activeRoute: string = '';

  pkLaudo: number = 0;
  disabledLaudo: boolean = false;
  title: string = 'Cadastrar Laudo de Higiênização';
  isEditing: boolean = false;

  statusInput: boolean = false;
  guid = generateUUID();
  servicoEntradaId: number = 0;
  isLoading: boolean = false;

  tipoLaudoOptions: IOptions[] = [
    {
      name: '',
      value: ''
    }
  ];

  motoristaOptions: IOptions[] = [
    {
      name: '',
      value: ''
    }
  ];

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private servicoEntradaService: ServicoEntradaService,
    private laudoHigienizacaoService: LaudoHigienizacaoService,
    public dialog: MatDialog,
    private swalAlert: SwalAlertService,
    private caminhaoService: CaminhaoService
  ) {
    this.form = this.initForm();
  }

  createPayload(): ICreateLaudoHigienizacao | IEditLaudoHigienizacao {
    return {
      TX_OBSV: this.form.controls['TX_OBSV'].value,
      TX_RG: this.form.controls['TX_RG'].value,
      QT_KM_CAVA: Number(this.form.controls['QT_KM'].value),
      FK_SRVC_ENTR: Number(this.form.controls['FK_SRVC_ENTR'].value),
      NM_FUNC_OPER: this.form.controls['NM_OPER'].value,
      NM_TRND: this.form.controls['NM_TRND'].value,
      TX_CPF_CNPJ_TRND: this.form.controls['TX_CPF_CNPJ_TRND'].value,
      NU_TELE_TRND: this.form.controls['NU_TELE_TRND'].value,
      TX_CPF: this.form.controls['TX_CPF'].value
    };
  }

  initForm(): FormGroup {
    const idEmpresa = localStorage.getItem('id') || '1'; //
    const form = this.fb.group({
      TX_PLCA_CAVA: this.fb.control('', {
        nonNullable: true,
        validators: [Validators.required]
      }),
      QT_KM: this.fb.control('', {
        nonNullable: true,
        validators: [Validators.required]
      }),
      PK_AGND: this.fb.control(''),
      FK_SRVC_ENTR: this.fb.control(''),
      NM_TRND: this.fb.control(''),
      TX_CPF_CNPJ_TRND: this.fb.control(''),
      DT_SRVC_ENTR: this.fb.control(''),
      NU_TELE_TRND: this.fb.control(''),
      NM_MTTR: this.fb.control(''),
      TX_RG: this.fb.control('', {
        nonNullable: true,
        validators: [Validators.required]
      }),
      TX_CPF: this.fb.control(''),
      TX_CRRT_1: this.fb.control(''),
      TX_CRRT_2: this.fb.control(''),
      TX_CRRT_3: this.fb.control(''),
      TX_TIPO_CRRT: this.fb.control(''),
      TX_TIPO_CRGA: this.fb.control(''),
      NM_OPER: this.fb.control('', {
        nonNullable: true,
        validators: [Validators.required]
      }),
      TX_OBSV: this.fb.control('')
    });
    return form;
  }

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    this.route.queryParams.subscribe(params => {
      if (params && Object.keys(params).length > 0) {
        this.title = 'Editar Laudo de Higienização';
        this.isLoading = true;
        this.isEditing = true;
        this.disabledLaudo = false;
        this.laudoHigienizacaoService
          .GetLaudoHigienizacaoById(Number(params['codigo']))
          .subscribe({
            next: (response: IGetLaudoHigienizacaoById) => {
              this.pkLaudo = response.PK_LAUD_SRVC;
              this.form.controls['FK_SRVC_ENTR'].setValue(
                Number(response.FK_SRVC_ENTR)
              );
              this.form.controls['QT_KM'].setValue(response.QT_KM_CAVA);
              this.form.controls['TX_RG'].setValue(response.TX_RG);
              this.form.controls['TX_OBSV'].setValue(response.TX_OBSV);
              this.form.controls['NM_OPER'].setValue(response.NM_FUNC_OPER);
              this.form.controls['TX_CPF'].setValue(response.TX_CPF);
              this.form.controls['NU_TELE_TRND'].setValue(
                response.NU_TELE_TRND
              );
              this.form.controls['NM_TRND'].setValue(response.NM_TRND);
              this.form.controls['TX_CPF_CNPJ_TRND'].setValue(
                response.TX_CPF_CNPJ_TRND
              );
              this.form.controls['PK_AGND'].setValue(response.PK_AGND);
              this.servicoEntradaId = response.FK_SRVC_ENTR;
              this.getServicoEntrada(response.FK_SRVC_ENTR);
            },
            error: (error: any) => {
              this.swalAlert.handleError(
                error,
                'Atenção!',
                'Ocorreu um erro ao buscar o Laudo de Higienização, por favor, tente novamente.',
                'warning'
              );
            },
            complete: () => {
              this.isLoading = false;
            }
          });
        if (params['modoLaudoHigienizacao'] == 'Visualizar') {
          this.title = 'Visualizar Laudo de Higienização';
          this.statusInput = true;
          this.disabledLaudo = true;
        }
      }
    });
  }

  setForms() {
    this.clearForms();
    this.getServicoEntrada();
  }

  getServicoEntrada(servicoEntradaId?: number) {
    this.isLoading = true;
    const placaCavalo = this.form.controls['TX_PLCA_CAVA'].value;
    const numeroAgendamento = this.form.controls['PK_AGND'].value;
    const servicoId = 3;

    const invalid = [null, '', undefined, 0];

    if (
      !invalid.includes(placaCavalo) ||
      !invalid.includes(servicoEntradaId) ||
      !invalid.includes(numeroAgendamento)
    ) {
      this.servicoEntradaService
        .GetServicoEntradaByServicoEntradaAndCavalo({
          PK_SRVC_ENTR: servicoEntradaId,
          PK_SRVC: servicoId,
          PK_AGND: numeroAgendamento,
          TX_PLCA_CAVA: placaCavalo
        })
        .subscribe({
          next: (response: IGetServicoEntradaByServicoEntradaCavalo) => {
            this.form.controls['TX_PLCA_CAVA'].setValue(response.TX_PLCA_CAVA);
            this.form.controls['TX_CRRT_1'].setValue(response.TX_PLCA_CRRT_1);
            this.form.controls['TX_CRRT_2'].setValue(response.TX_PLCA_CRRT_2);
            this.form.controls['TX_CRRT_3'].setValue(response.TX_PLCA_CRRT_3);

            this.form.controls['FK_SRVC_ENTR'].setValue(response.PK_SRVC_ENTR);
            this.form.controls['DT_SRVC_ENTR'].setValue(
              formatarData(response.DT_SRVC_ENTR)
            );

            this.form.controls['NM_MTTR'].setValue(response.NM_USUA_MTRT);
            this.form.controls['TX_TIPO_CRRT'].setValue(response.NM_TIPO_CRRT);
            this.form.controls['TX_TIPO_CRGA'].setValue(response.TX_CRGA);
            this.form.controls['PK_AGND'].setValue(response.PK_AGND);

            if (!this.form.controls['TX_CPF_CNPJ_TRND'].value)
              this.form.controls['TX_CPF_CNPJ_TRND'].setValue(
                response.TX_CNPJ_EPSA
              );
            if (!this.form.controls['TX_CPF'].value)
              this.form.controls['TX_CPF'].setValue(response.TX_CPF_MTRT);
            if (!this.form.controls['NU_TELE_TRND'].value)
              this.form.controls['NU_TELE_TRND'].setValue(
                response.NU_TELE_EPSA
              );
            if (!this.form.controls['NM_TRND'].value)
              this.form.controls['NM_TRND'].setValue(response.NM_FNTS_EPSA);

            this.isLoading = false;
          },
          error: (error: any) => {
            this.swalAlert.handleError(
              error,
              'Atenção!',
              'Ocorreu um erro ao realizar a busca através da Placa do Cavalo ou Número do serviço, por favor, tente novamente.',
              'warning'
            );
            this.isLoading = false;
          },
          complete: () => {
            this.isLoading = false;
          }
        });
    }

    this.isLoading = false;
  }
  clearForms(): void {
    const placaCavalo = this.form.controls['TX_PLCA_CAVA'].value;

    if (placaCavalo == '') this.form.reset();
  }

  ngOnDestroy(): void {
    this.subscription$.unsubscribe();
  }
}
